// This model exists to fix the chrome bug where switching the camera a bunch of times in a call mutes audio

/**
 * @module Calling
 * @description
 */

var Model = require("../types/Model.js");

var SWITCH_LIMIT = 6;

module.exports = Model({
	name: "ringfixer",
	_should_refresh: false,
	_switch_count: 0,
	_is_online: false,
	listeners: listeners,
});

function listeners(){
	return {
		"online:updated": handle_online_status,
		"inputoptions:renegotiating": handle_renegotiate,
		"calling:state:idle": handle_call_idle,
		"machinetracker:updated": handle_machinetracker_update,
	};
}

function handle_renegotiate(){
	this._switch_count++;
}

function handle_call_idle(){
	var count = this._switch_count;
	if(!count) return;
	this._switch_count = 0;
	if(!this._is_online) return;
	if(count < SWITCH_LIMIT) return;
	this.emit("refresher:trigger:refresh");
}

function handle_machinetracker_update(machine){
	var apk = machine.apk || "";
	if(apk.indexOf("4.0.") !== -1)
		this._should_refresh = true;
}

function handle_online_status(status){
	this._is_online = status;
}